import { deepMerge } from '@packages/shared';

const normalizeDomain = (domain: string): string => {
  const trimmedDomain = domain.trim();
  return trimmedDomain.endsWith('/')
    ? trimmedDomain.slice(0, -1)
    : trimmedDomain;
};

export function useConfig() {
  const globalConfig = {
    // 这里可以预加载一些默认配置
    intellisightUrl: 'INTELLIDO_DOMAIN', // niepan-web 地址（测试域名示例：http://intellisight.aialign.cn）
    showFunctionDefinitionMenu: false, // 是否显示函数定义菜单
    showSimulationExecuteButton: false, // 是否显示仿真执行按钮
    showLLMModelOption: false, // 是否在执行逻辑面板显示「LLM大模型」过程类型选项
    enableProcessNodeCascade: false,
    enableOPMEditorAutoSave: false,
  };

  // _server_niepan_config
  const serverConfig = {
    // 这里可以预加载一些默认配置
  };

  const _global = window as any;

  // 动态从 window 获取
  if (!_global._intellix_global_config) {
    console.warn(
      '请注意，当前未正确挂载 _intellix_global_config，请检查部署环境是否正确部署了 config.js'
    );
    _global._intellix_global_config = {};
  }

  if (!_global._intellix_server_config) {
    console.warn(
      '请注意，当前未正确挂载 _intellix_server_config，请检查部署环境是否正确部署了 config.js'
    );
    _global._intellix_server_config = {};
  }

  // 使用深度合并替代浅合并，确保嵌套对象和数组正确合并
  const mergedGlobalConfig = deepMerge(
    globalConfig,
    _global._intellix_global_config
  );

  // 统一处理域名格式，避免拼接路径时出现双斜杠
  if (typeof mergedGlobalConfig.intellisightUrl === 'string') {
    mergedGlobalConfig.intellisightUrl = normalizeDomain(
      mergedGlobalConfig.intellisightUrl
    );
  }

  const mergedServerConfig = deepMerge(
    serverConfig,
    _global._intellix_server_config
  );

  return {
    globalConfig: mergedGlobalConfig,
    serverConfig: mergedServerConfig,
  };
}
